"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComparisonOpcodeTemplates = getComparisonOpcodeTemplates;
function getComparisonOpcodeTemplates() {
    return `
                        // Logical Operations
                        case opMap[32]: // LOGICAL_NOT
                            stack.push(!stack.pop());
                            pc++;
                            break;

                        // Comparison Operations
                        case opMap[40]: { // EQ
                            let b = stack.pop();
                            let a = stack.pop();
                            stack.push(a == b);
                            pc++;
                            break;
                        }

                        case opMap[41]: { // NEQ
                            let b = stack.pop();
                            let a = stack.pop();
                            stack.push(a != b);
                            pc++;
                            break;
                        }

                        case opMap[42]: { // STRICT_EQ
                            let b = stack.pop();
                            let a = stack.pop();
                            stack.push(a === b);
                            pc++;
                            break;
                        }

                        case opMap[43]: { // STRICT_NEQ
                            let b = stack.pop();
                            let a = stack.pop();
                            stack.push(a !== b);
                            pc++;
                            break;
                        }

                        case opMap[44]: { // LT
                            let b = stack.pop();
                            let a = stack.pop();
                            stack.push(a < b);
                            pc++;
                            break;
                        }

                        case opMap[45]: { // LTE
                            let b = stack.pop();
                            let a = stack.pop();
                            stack.push(a <= b);
                            pc++;
                            break;
                        }

                        case opMap[46]: { // GT
                            let b = stack.pop();
                            let a = stack.pop();
                            stack.push(a > b);
                            pc++;
                            break;
                        }

                        case opMap[47]: { // GTE
                            let b = stack.pop();
                            let a = stack.pop();
                            stack.push(a >= b);
                            pc++;
                            break;
                        }
    `;
}
